// eslint-disable-next-line import/prefer-default-export
export const GET_WORKSPACES_QUERY = `
  query getWorkspaces {
    me {
      workspaceMemberships(limit: 60) {
        entries {
          role
          workspace {
            identifier
            name
            type
            customer {
              ssoEnabled
              identifier
            }
          }
        }
      }
    }
  }
`

// eslint-disable-next-line import/prefer-default-export
export const GET_SUBSCRIPTION_INFO_QUERY = `
  query getCustomer($customerId: UUID!) {
    customer(id: $customerId) {
      subscription {
        status
        subscriptionEnd
        currentPlan {    
          product
        }
      }
    }
  }
`

export const GET_PLANS_AND_LICENSE_PRICES = `
  query getPlansAndLicensePrices {
    licensePlan {
      prices {
        ...Price
      }
    }
    availableCloudPlans {
      ...CloudBillingPlan
    }
  }

  fragment Price on Price {
    amount
    currency
  }

  fragment BillingPrice on BillingPrice {
    invoice
    monthly
    currency
  }

  fragment CloudBillingPlan on CloudBillingPlan {
    id
    type
    product
    prices {
      ...BillingPrice
    }
  }
`

export const GET_CLIENT_CURRENCIES = `
  query getClientCurrencies($token: String) {
    currencies(token: $token) {
      available
      default
    }
  }
`
